import { actions, EventObject, forwardTo } from "xstate"
import { SanitySuite } from "../../../../_common/sanity/sanity-types"
import { ReceiptStateMachine } from "../receipt-machine"
import { suiteCategoriesMachine } from "../suite-categories-machine"
import { ECommerceStateNodeConfig } from "./e-commerce-machine"

export const readModelsConfig = (
    suitesSanity: readonly SanitySuite[],
    receiptMachine: () => ReceiptStateMachine,
): ECommerceStateNodeConfig => ({
    type: "parallel",
    states: {
        receipt: {
            invoke: {
                id: "receiptReadModel",
                src: receiptMachine(),
            },
            on: {
                "*": { actions: forwardTo("receiptReadModel") },
            },
        },

        suite_categories: {
            invoke: {
                id: "suiteCategoriesReadModel",
                src: suiteCategoriesMachine(suitesSanity),
            },
            on: {
                "*": { actions: forwardTo("suiteCategoriesReadModel") },
            },
        },

        suite_number_validator: {
            on: {
                AVAILABLE_SUITES_LOADED: {
                    actions: pure((ctx, ev) => ctx.suiteNumberValidator.availableSuitesLoaded(ev.response)),
                },
                SUITE_PRICES_LOADED: {
                    actions: pure((ctx, ev) => ctx.suiteNumberValidator.pricesLoaded(ev.prices)),
                },
                SUITE_CATEGORY_SELECTED: {
                    actions: pure((ctx, ev) => ctx.suiteNumberValidator.suiteCategorySelected(ev.suiteCategory)),
                },
                SUITE_CATEGORY_UNSELECTED: {
                    actions: pure((ctx) => ctx.suiteNumberValidator.suiteCategoryUnselected()),
                },
            },
        },

        suite_category_validator: {
            on: {
                SUITE_PRICES_LOADED: {
                    actions: pure((ctx, ev) => ctx.suiteCategoryValidator.pricesLoaded(ev.prices)),
                },
            },
        },
    },
})

const pure = <C, E extends EventObject>(fn: (ctx: C, ev: E) => void) =>
    actions.pure((ctx: C, ev: E) => {
        fn(ctx, ev)
        return undefined
    })
